// extracted by mini-css-extract-plugin
module.exports = {"oneColumnLayout":"oneColumnLayout_oneColumnLayout__1wyfe","content":"oneColumnLayout_content__2oxs0"};